import { useLingui } from '../../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default from 'react';
import Button from '../../../components/atoms/Button.mjs';
import Column from '../../../components/atoms/Column.mjs';
import TextColumn from '../../../components/molecules/TextColumn.mjs';
import { useGlobalReducer, AppScreens } from '../../GlobalContextProvider.mjs';

const Error$1 = ()=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    const [, dispatch] = useGlobalReducer();
    return /*#__PURE__*/ React__default.createElement(Column, {
        gap: 6
    }, /*#__PURE__*/ React__default.createElement(TextColumn, {
        header: $__i18n._({
            id: "crypto.error.title"
        }),
        body: $__i18n._({
            id: "crypto.error.content"
        })
    }), /*#__PURE__*/ React__default.createElement(Button, {
        variant: "outline",
        onClick: ()=>dispatch({
                type: 'transition',
                screen: AppScreens.Main
            })
    }, $__i18n._({
        id: "button.goBack"
    })));
};

export { Error$1 as Error };
//# sourceMappingURL=Error.mjs.map
